// extracted by mini-css-extract-plugin
module.exports =  {"warning_border":"MessageWarning-module__warning_border___tzpdO"};